import './dateRangeFilter.css'

import React from 'react'

import { DateRangeSelection } from '@/components'
import { useTicketFiltersContext } from '@/context/filters/ticketFilters/ticketFilters'

export const DateRangeFilter = ({ className }: { className?: string }) => {
  const { setFilters, startingCreatedAtDate, endingCreatedAtDate } = useTicketFiltersContext()
  return (
    <DateRangeSelection
      className={className}
      endDate={endingCreatedAtDate}
      headerTitle="Created Date"
      listFilter={true}
      pastSelection={true}
      setEndDate={(d?: Date) => {
        setFilters({
          endingCreatedAtDate: d,
        })
      }}
      setStartDate={(d?: Date) => {
        setFilters({
          startingCreatedAtDate: d,
        })
      }}
      startDate={startingCreatedAtDate}
    />
  )
}
